<template>
	<div>
		<!-- ------------------------------Email登入開始------------------------------ -->
        <div class="modal fade cm-modal" id="emailLoginModal" tabindex="-1" role="dialog"
            aria-labelledby="emailLoginModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered cm-modal-emailLoginModal" role="document">
                <div class="modal-content">
                    <div class="modal-header text-center text-white cm-modal-emailLoginModal-header">
                        <h4 class='col-12 modal-title text-center'>
                            Email
                            <button type="button" class="close cm-emailLogin-close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="@/assets/images/login-close.png">
                                </span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body px-5 cm-modal-emailLogin-body">
                        <div class="form-group row">
                            <div class="col-md-12">
                                <input v-model="input.email" v-on:blur="emailInputMonitor" type="text" class="form-control" placeholder="Email">
                            </div>
                            <div v-if="prompt.emailErrStr!=''" class="col-md-12 text-danger">
                                {{prompt.emailErrStr}}
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-6 mb-0 mb-3 mb-md-0">
                                <input v-model="input.authCode" v-on:blur="authCodeInputMonitor" type="text" class="form-control" :placeholder="$t('modal.EmailLogin.Placeholder.AuthCode')">
                                <div v-if="prompt.authCodeErrStr!=''" class="d-md-none text-danger px-0">
                                    {{prompt.authCodeErrStr}}
                                </div>
                            </div>
                            <div class="col-md-6 col d-flex justify-content-center">
                                <div class="d-flex justify-content-center">
                                    <div v-if="domControl.isWaitingEmailSendCodeAjax==true" class="mt-1 mr-md-3 spinner-border text-warning text-center" role="status"></div>
                                    <button v-if="domControl.isWaitingEmailSendCodeAjax==false" @click="clickEmailSendCode()" type="button" class="btn btn-lg text-white cm-emailLogin-emailSendCode-button" :disabled="domControl.isDisableEmailSendCodeButton">{{$t('modal.EmailLogin.Button.EmailSendCode')}}</button>
                                    <input v-if="domControl.isWaitingEmailSendCodeAjax==false" style="width: 45px;" class="form-control cm-emailLogin-countdown-prompt" :placeholder="prompt.countDownTimer" readonly>
                                </div>
                            </div>
                            <div v-if="prompt.authCodeErrStr!=''" class="d-none d-md-block col-md-12 text-danger">
                                {{prompt.authCodeErrStr}}
                            </div>
                        </div>
                        <div class="form-group d-flex justify-content-center text-danger">
                            {{prompt.apiResponse}}
                        </div>
                        <div class="col py-2 d-flex justify-content-center">
                            <div v-if="domControl.isWaitingEmailLoginAjax==true" class="mt-1 mr-md-3 spinner-border text-warning text-center" role="status"></div>                        
                            <button v-else @click="clickEmailLogin()" type="button" class="btn btn-lg text-white cm-emailLogin-send-button">{{$t('modal.EmailLogin.Button.Login')}}</button>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-emailLogin-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------Email登入結束------------------------------ -->
	</div>
</template>

<script>
import axios from 'axios'
import CookieUtil from "@/assets/js/util/CookieUtil.js"
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js"
import ShowMsg from "@/assets/js/util/ShowMsg.js";
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'
export default {
    data() {
        return {
            setting: {
                countDownSeconds: 60, // 要求後端寄送驗證碼後的讀秒，讀完才能再寄
            },
            input: {
                email: "", 
                authCode: ""
            },
            prompt: {
                countDownTimer: "", // 倒數計時器
                emailErrStr: "", // email驗證錯誤訊息
                authCodeErrStr: "", // 驗證碼驗證錯誤訊息
                apiResponse: "", // API回覆的錯誤訊息
            },
            domControl: {
                isDisableEmailSendCodeButton: false,
                isWaitingEmailSendCodeAjax: false,
                isWaitingEmailLoginAjax: false
            },
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            // 判斷寄送驗證碼後的倒數計時是否還需要繼續倒數
            if(false != CookieUtil.getCookie(process.env.VUE_APP_COOKIE_EMAILLOGIN_AUTHCODE_SEND_TS)) {
                const a = new Date().getTime()
                // 依照cookie值是否為數字做不同處理
                if(false == isNaN(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_EMAILLOGIN_AUTHCODE_SEND_TS))) { // 算出還需要倒數幾秒，顯示至頁面上
                    const authCodeSendTs = parseInt(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_EMAILLOGIN_AUTHCODE_SEND_TS))
                    const countDownMilliseconds = authCodeSendTs + (this.setting.countDownSeconds*1000) - new Date().getTime()
                    if(countDownMilliseconds > 0) {
                        this.startTimer(countDownMilliseconds/1000)
                    }
                }
                else { // cookie取出的值不為數字，重新倒數
                    CookieUtil.setCookie(process.env.VUE_APP_COOKIE_EMAILLOGIN_AUTHCODE_SEND_TS, new Date().getTime(), {"max-age": this.setting.countDownSeconds})
                    this.startTimer(this.setting.countDownSeconds)
                }
            }
        },
        emailInputMonitor() {
            // 驗證email字串不為空，且符合格式
            this.prompt.emailErrStr = ValidatorUtil.validEmail(this.input.email, {
                'req': this.$i18n.t('modal.EmailLogin.Validate.Email.req'),
                'format': this.$i18n.t('modal.EmailLogin.Validate.Email.format'),
            })
        },
        authCodeInputMonitor() {
            // 檢查驗證碼只為英數字
            this.prompt.authCodeErrStr = ValidatorUtil.validEngNumOnly(this.input.authCode, {
                'engNumOnly': this.$i18n.t('modal.EmailLogin.Validate.AuthCode.engNumOnly')
            })
            // 驗證碼為空
            if(this.input.authCode.trim() == "") {
                this.prompt.authCodeErrStr = this.$i18n.t('modal.EmailLogin.Validate.AuthCode.blank')
            }
        },
        // 點擊"寄送驗證碼"按鈕
        clickEmailSendCode() {
            // 清除錯誤提示
            this.prompt.emailErrStr = ""
            this.prompt.authCodeErrStr = ""
            this.prompt.apiResponse = ""

            // 檢查Email
            this.emailInputMonitor()
            if(this.prompt.emailErrStr != "") {
                return false;
            }

            // 寄送驗證碼
            this.ajaxFrontendEmailSendCodeAction()
        },
        clickEmailLogin() {
            // 清除錯誤提示
            this.prompt.emailErrStr = ""
            this.prompt.authCodeErrStr = ""
            this.prompt.apiResponse = ""

            // 檢查Email
            this.emailInputMonitor()
            if(this.prompt.emailErrStr != "") {
                return false;
            }

            // 檢查驗證碼
            this.authCodeInputMonitor()
            if(this.prompt.authCodeErrStr != "") {
                return false;
            }
            
            this.ajaxFrontendEmailCheckCodeAction()
        },
        // 寄送驗證碼至信箱
        ajaxFrontendEmailSendCodeAction() {
            const self = this
            RecaptchaUtil.startGoogleRecaptchaVerify(
                process.env.VUE_APP_AUTH_RECAPTCHA_EMAILLOGIN_SENDCODE,
                async function(gRecaptchaResponse) {
                    let bodyFormData = new FormData();
                    bodyFormData.append("email", self.input.email);
                    bodyFormData.append("request_locale", self.$i18n.locale.replace("-", "_"));
                    bodyFormData.append("mydomain", "all9fun.com");
                    bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
                    
                    // 開啟Ajax等待動畫
                    self.domControl.isWaitingEmailSendCodeAjax = true;

                    // Ajax
                    const response = await axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendEmailSendCodeAction.shtml",
                        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                        data: bodyFormData,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    .catch(function(response) {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                    })
                    
                    // 關閉Ajax等待動畫
                    self.domControl.isWaitingEmailSendCodeAjax = false;
                    
                    // 判斷Ajax結果
                    if(response!=undefined && response.data!=undefined) {
                        if(response.data.result=="success") { // 驗證碼寄送成功
                            // 啟動倒數計數器
                            self.startTimer(self.setting.countDownSeconds)
                            // 將倒數計時起始時間點記錄至cookie
                            CookieUtil.setCookie(process.env.VUE_APP_COOKIE_EMAILLOGIN_AUTHCODE_SEND_TS, new Date().getTime(), {"max-age": self.setting.countDownSeconds})
                            // 提示成功
                            alert(self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.Success'));
                        }
                        else { // 驗證碼寄送失敗
                            // 依照不同的message訊息給與對應的錯誤訊息
                            const message = response.data.message
                            let errorStr = self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.ErrorMsg.UnknownError') // 預設
                            if(message.split(".").length > 0) {
                                const messageArr = message.split(".")
                                const errorCode = messageArr[messageArr.length - 1]
                                if(errorCode == "ErrorCodeNotice") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.ErrorMsg.ErrorCodeNotice')
                                }
                                else if(errorCode == "ErrorCodeWait") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.ErrorMsg.ErrorCodeWait')
                                }
                                else if(errorCode == "EmailBlank") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.ErrorMsg.EmailBlank')
                                }
                                else if(errorCode == "EmailFormat") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.ErrorMsg.EmailFormat')
                                }
                                else if(errorCode == "EmailRepeatSend") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.SendAuthCode.Response.ErrorMsg.EmailRepeatSend')
                                }
                                else if(errorCode == "GoogleRecaptchaError") {
                                    errorStr = self.$i18n.t('common.Backend.Response.GoogleRecaptchaError')
                                }
                            }

                            // response若帶有extra，則需將其中的參數置換到字串中
                            if(response.data.extra!=undefined && Array.isArray(response.data.extra) && response.data.extra.length>0) {
                                errorStr = self.replaceErrorMsgParam(errorStr, response.data.extra)
                            }

                            self.prompt.apiResponse = errorStr
                        }
                    }
                }
            )
        },
        // 確認驗證碼
        ajaxFrontendEmailCheckCodeAction() {
            const self = this
            RecaptchaUtil.startGoogleRecaptchaVerify(
                process.env.VUE_APP_AUTH_RECAPTCHA_EMAILLOGIN_CHECKCODE,
                async function(gRecaptchaResponse) {
                    let bodyFormData = new FormData();
                    bodyFormData.append("email", self.input.email);
                    bodyFormData.append("checkCode", self.input.authCode);
                    bodyFormData.append("request_locale", self.$i18n.locale.replace("-", "_"));
                    bodyFormData.append("mydomain", "all9fun.com");
                    bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
                    
                    // 開啟Ajax等待動畫
                    self.domControl.isWaitingEmailLoginAjax = true;

                    // Ajax
                    const response = await axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendEmailCheckCodeAction.shtml",
                        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                        data: bodyFormData,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    .catch(function(response) {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                    })
                    
                    // 關閉Ajax等待動畫
                    self.domControl.isWaitingEmailLoginAjax = false;
                    
                    // 判斷Ajax結果
                    if(response!=undefined && response.data!=undefined) {
                        if(response.data.result=="success") { // 驗證碼寄送成功
                           self.ajaxFrontendEmailLoginActionV20()
                        }
                        else { // 驗證碼寄送失敗
                            // 依照不同的message訊息給與對應的錯誤訊息
                            const message = response.data.message
                            let errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.UnknownError') // 預設

                            if(message.split(".").length > 0) {
                                const messageArr = message.split(".")
                                const errorCode = messageArr[messageArr.length - 1]
                                if(errorCode == "CheckCodeBlank") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.CheckCodeBlank')
                                }
                                else if(errorCode == "EmailBlank") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.EmailBlank')
                                }
                                else if(errorCode == "EmailFormat") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.EmailFormat')
                                }
                                else if(errorCode == "NotMatch") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.NotMatch')
                                }
                                else if(errorCode == "NotMatchAndResend") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.NotMatchAndResend')
                                }
                                else if(errorCode == "ServerBusy") {
                                    errorStr = self.$i18n.t('modal.EmailLogin.Ajax.CheckAuthCode.Response.ErrorMsg.ServerBusy')
                                }
                                else if(errorCode == "GoogleRecaptchaError") {
                                    errorStr = self.$i18n.t('common.Backend.Response.GoogleRecaptchaError')
                                }
                            }

                            self.prompt.apiResponse = errorStr
                        }
                    }
                }
            )
        },
        // 以Email與驗證碼進行登入
        ajaxFrontendEmailLoginActionV20() {
            const self = this
            RecaptchaUtil.startGoogleRecaptchaVerify(
                process.env.VUE_APP_AUTH_RECAPTCHA_EMAILLOGIN_LOGIN,
                async function(gRecaptchaResponse) {
                    let bodyFormData = new FormData();
                    bodyFormData.append("email", self.input.email);
                    bodyFormData.append("checkCode", self.input.authCode);
                    bodyFormData.append("mydomain", "all9fun.com");
                    bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
                    
                    // 開啟Ajax等待動畫
                    self.domControl.isWaitingEmailLoginAjax = true;

                    // Ajax
                    const response = await axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendEmailLoginActionV20.shtml",
                        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                        data: bodyFormData,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    .catch(function(response) {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                    })
                    
                    // 關閉Ajax等待動畫
                    self.domControl.isWaitingEmailLoginAjax = false;
                    
                    // 判斷Ajax結果
                    if(response!=undefined && response.data!=undefined) {
                        if(response.data.result=="success") { // 驗證碼寄送成功
                            CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE, response.data.loginKey);
                            CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_ACCOUNT, response.data.account);
                            window.location.href = "/";
                        }
                        else { // 驗證碼寄送失敗
                            // 依照不同的message訊息給與對應的錯誤訊息
                            const errorCode = response.data.errorCode
                            let errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E999') // 發生不明錯誤，請通知客服人員
                            if(errorCode == "E001") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E001') // 參數不足
                            }
                            else if(errorCode == "E002") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E002') // 驗證碼錯誤
                            }
                            else if(errorCode == "E016") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E016') // 帳號停用中
                            }
                            else if(errorCode == "E017") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E017') // Email格式錯誤
                            }
                            else if(errorCode == "E018") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E018') // 驗證失敗，請重新寄信
                            }
                            else if(errorCode == "E019") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E019') // 驗證失敗，系統繁忙中，請稍後再試
                            }
                            else if(errorCode == "E020") {
                                errorStr = self.$i18n.t('modal.EmailLogin.Ajax.FrontendEmailLogin.Response.ErrorCode.E020') // Google reCAPTCHA驗證失敗
                            }
                            ShowMsg.showModal(errorStr, {"text-align":"center"});
                        }
                    }
                }
            )
        },
        // 啟動倒數計時器
        startTimer(countDownSeconds) {
            this.prompt.countDownTimer = parseInt(countDownSeconds)
            this.domControl.isDisableEmailSendCodeButton = true
            const self = this
            let countDownTimer = setInterval(() => {
                self.prompt.countDownTimer -= 1
                if(self.prompt.countDownTimer == 0) { // 計數器歸0
                    self.prompt.countDownTimer = ""
                    this.domControl.isDisableEmailSendCodeButton = false
                    clearInterval(countDownTimer)
                }
            }, 1000);
        },
        // 替換字串，ex: str=aa{0}bb{1}, paramsArr=["A", "B"], result=aaAbbB
        replaceErrorMsgParam(str, paramsArr) {            
            for (let i = 0; i < paramsArr.length; i++) {
                const param = paramsArr[i]
                str = str.replace(`{${i}}`, param)
            }
            return str
        },
    }
}
</script>